var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._b({on:{"input":function($event){return _vm.$emit('input')}}},'textarea',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }